import { jsx as _jsx } from "react/jsx-runtime";
import { makeStyles, createStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
const useStyles = makeStyles((theme) => createStyles({
    modal: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3)
    }
}));
export const ModalContainer = (props) => {
    const { open, handleClose, children } = props;
    const classes = useStyles();
    return (_jsx(Modal, { className: classes.modal, open: open, onClose: handleClose, closeAfterTransition: true, BackdropComponent: Backdrop, BackdropProps: {
            timeout: 500
        }, children: _jsx(Fade, { in: open, children: _jsx("div", { className: classes.paper, children: children }) }) }));
};
//# sourceMappingURL=ModalContainer.js.map